import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
const heroImage = 'https://cdn.magicpatterns.com/patterns/generated-images/5760514a-74e6-44d7-8048-8dae78093729.jpg';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="top" aria-labelledby="hero-title" data-id="element-172" data-mp="4m8mecr76rkx">
      <div className="relative flex min-h-[560px] items-end overflow-hidden lg:min-h-[640px]" style={{
      height: 'calc(100vh - 4rem - 56px)'
    }} data-id="element-173" data-mp="4njng4t9dl8c">
        <img src={heroImage} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-174" data-mp="x9urjpg2q49w" />
        <div className="absolute inset-0 bg-bark/45" aria-hidden="true" data-id="element-175" data-mp="sb1efy4p8fa9" />
        <div className="relative mx-auto w-full max-w-7xl px-5 pb-14 lg:px-8 lg:pb-20" data-id="element-176" data-mp="sd4cn5g09eq2">
          <div className="max-w-2xl" data-id="element-177" data-mp="neaugzprwzjk">
            <p className="mb-4 flex items-center gap-3 font-serif text-lg italic text-cream/90 md:text-xl" data-id="element-178" data-mp="3d21tk0zn2qpb">
              <span className="h-px w-10 bg-cream/60" aria-hidden="true" data-id="element-179" data-mp="3825y4q50c7ld" />
              {t.hero.location}
            </p>
            <h1 id="hero-title" className="font-serif text-5xl font-bold leading-[1.05] text-cream md:text-6xl lg:text-7xl" data-id="element-180" data-mp="3j9u0ky5t7mla">
              {t.hero.title}
            </h1>
            <p className="mt-5 max-w-xl text-lg leading-relaxed text-cream/90 md:text-xl" data-id="element-181" data-mp="39autvl4lu10x">{t.hero.subtitle}</p>
            <div className="mt-8 flex flex-wrap gap-3" data-id="element-182" data-mp="3e8efj63mtg2w">
              <a href="#booking" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-hay px-6 py-3 font-bold text-bark transition-colors duration-150 hover:bg-straw" data-id="element-183" data-mp="3eb8xmqz6aot5">
                {t.hero.cta}
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-184" data-mp="2qlelkbmoh49y" />
              </a>
              <a href="#horses" className="inline-flex whitespace-nowrap rounded-full border border-cream/60 px-6 py-3 font-bold text-cream transition-colors duration-150 hover:bg-cream/10" data-id="element-185" data-mp="2vjpvsngvxgsp">
                {t.hero.secondary}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-bark text-straw" data-id="element-186" data-mp="nbb9spq0zv12">
        <div className="mx-auto flex max-w-7xl flex-col gap-1 px-5 py-4 text-sm sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-6 lg:px-8" data-id="element-187" data-mp="najgjljwi9dy">
          <p className="font-bold text-cream" data-id="element-188" data-mp="i9vp4yrrfqj7">{t.notice.rides}</p>
          <p data-id="element-189" data-mp="deq8ofh4n42i">
            {t.notice.events}{' '}
            <a href="#events" className="font-bold text-hay underline underline-offset-4 hover:text-cream" data-id="element-190" data-mp="1b0ni7ndj3z2b">
              {t.notice.link}
            </a>
          </p>
        </div>
      </div>
    </section>;
}